window.app.directive("msValidate", [
  "$timeout",
  function($timeout) {
    return {
      require: "ngModel",
      restrict: "A",
      scope: { msValidate: "&" },
      link: function(scope, element, attr, mCtrl) {
        const validator = scope.msValidate();
        console.warn("Validator", { validator });
        let msgEl = element.parent()[0].querySelector(".input-message");
        if (!msgEl) {
          msgEl = document.createElement("span");
          msgEl.className = "input-message";
          element.parent()[0].appendChild(msgEl);
        }
        mCtrl.$overrideModelOptions({ allowInvalid: true });
        element.on("blur", () => {
          $timeout(() => mCtrl.$validate(), 10);
        });
        mCtrl.$validators.msValidate = v => {
          const out = scope.msValidate()(v);
          console.warn("msvalidate", { out, $touched: mCtrl.$touched });
          if (msgEl) {
            if (out !== undefined && mCtrl.$touched) {
              msgEl.innerHTML = out;
            } else {
              msgEl.innerHTML = "";
            }
          }
          return out === undefined || !mCtrl.$touched;
        };
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/msValidate.js